import { SideNavigationProps } from '@zeiss/beyond-online-react';

import { getNavigationElementIsActive } from '.';

interface GetNavigationGroupsProps {
  groups: SideNavigationProps['groups'];
  pathname: string;
}
export const getNavigationGroups = ({
  groups,
  pathname,
}: GetNavigationGroupsProps) => {
  return groups.map((group) =>
    group.map((category) => {
      /* istanbul ignore if -- @preserve */
      if (category.subCategories) {
        return {
          ...category,
          subCategories: category.subCategories.map((subCategory) => ({
            ...subCategory,
            active: getNavigationElementIsActive({
              href: subCategory.href,
              pathname,
            }),
          })),
        };
      }
      return {
        ...category,
        active: getNavigationElementIsActive({ href: category.href, pathname }),
      };
    }),
  );
};
